// Display helpers shared by the billing screens (Claims → Runs).

import { format, parseISO } from 'date-fns';

export const STATUS_COLOR = {
  draft:     { bg: 'var(--bg2)',        color: 'var(--text3)',   label: 'Draft' },
  approved:  { bg: 'var(--info-bg)',    color: 'var(--info)',    label: 'Approved' },
  submitted: { bg: 'var(--warn-bg)',    color: 'var(--warn)',    label: 'Submitted' },
  closed:    { bg: 'var(--success-bg)', color: 'var(--success)', label: 'Closed' },
};
export const LINE_STATUS_COLOR = {
  pending:   { bg: 'var(--bg2)',        color: 'var(--text3)'  },
  approved:  { bg: 'var(--info-bg)',    color: 'var(--info)'   },
  submitted: { bg: 'var(--warn-bg)',    color: 'var(--warn)'   },
  paid:      { bg: 'var(--success-bg)', color: 'var(--success)'},
  denied:    { bg: 'var(--danger-bg)',  color: 'var(--danger)' },
  adjusted:  { bg: 'var(--warn-bg)',    color: 'var(--warn)'   },
  voided:    { bg: 'var(--bg2)',        color: 'var(--text3)'  },
};
export const DENIAL_CODES = [
  'CO-4','CO-11','CO-15','CO-16','CO-29','CO-97','CO-167',
  'PR-2','PR-27','MA130','ELIG','AUTH','DUP','MED','OTHER',
];
export const fmt$2 = (n) => n != null ? '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '—';
export const fmt$  = (n) => n != null ? '$' + Number(n).toLocaleString('en-US', { maximumFractionDigits: 0 }) : '—';
export const fmtDate = (d) => d ? format(parseISO(d), 'MMM d, yyyy') : '—';

/** Hand the browser a file built in memory. */
export const downloadText = (text, fileName, mime = 'text/plain;charset=utf-8') => {
  const a = document.createElement('a');
  a.href = `data:${mime},` + encodeURIComponent(text);
  a.download = fileName;
  a.click();
};
